/* global app, moment */
import { mapState } from 'vuex'

export default {
    methods: {
        resetPrices () {
            this.$store.commit('tenant/setPrices', {
                yearly: app.config.YEARLY_PRICE,
                monthly: app.config.MONTHLY_PRICE,
                total_yearly: this.currentTenant.formatted_total_yearly_price,
                total_monthly: this.currentTenant.formatted_total_monthly_price
            })
        }
    },

    computed: {
        ...mapState('tenant', {
            currentTenant: 'tenant'
        }),

        currentSubscription () {
            return this.currentTenant.current_subscription
        },

        subscriptionEndsAt () {
            return moment(this.currentSubscription.ends_at).format('MMMM Do, YYYY')
        },

        currentPlan () {
            return this.isSubscribed ? 'Pro' : 'Free'
        },

        isSubscribed () {
            return this.currentSubscription !== null
        },

        isCancelled () {
            return this.isSubscribed && this.currentSubscription.ends_at !== null
        },

        isNotSubscribed () {
            return this.isSubscribed === false
        },

        hasPaymentMethod () {
            return this.currentTenant.card_last_four !== null
        },

        paymentMethodDetails () {
            return `${this.currentTenant.card_brand} ************${this.currentTenant.card_last_four}`
        }
    }
}
